// Mock data for Siyaanish luxury boutique
import womenImage from '../assets/women.jpeg';
import menImage from '../assets/men.jpeg';
import lifestyleImage from '../assets/lifestyle.jpeg';
import siyaanishsig from '../assets/siyaanishsignature.jpeg';
export const products = [
  {
    id: 1,
    name: "Organic Cotton Oversized Shirt",
    price: 4500,
    category: "women",
    fabric: "Organic Cotton",
    images: [
      "https://images.unsplash.com/photo-1615453590051-9cc24146d6ae?w=800&q=80",
      "https://images.unsplash.com/photo-1746730921292-bd6be2c256d5?w=800&q=80"
    ],
    sizes: ["XS", "S", "M", "L", "XL"],
    description: "A timeless oversized shirt crafted from 100% organic cotton. Breathable and perfect for everyday luxury.",
    careInstructions: "Machine wash cold. Tumble dry low. Iron on low heat.",
    ethical: "Made with fair trade certified organic cotton. Small batch production.",
    stock: 15
  },
  {
    id: 2,
    name: "Linen Blend Wide Leg Trousers",
    price: 5200,
    category: "women",
    fabric: "Linen Blend",
    images: [
      "https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?w=800&q=80",
      "https://images.unsplash.com/photo-1624206112918-f140f087f9b5?w=800&q=80"
    ],
    sizes: ["XS", "S", "M", "L", "XL"],
    description: "Effortlessly elegant wide-leg trousers in a premium linen blend. Cool and comfortable.",
    careInstructions: "Dry clean recommended. Hand wash cold if needed.",
    ethical: "Sustainably sourced linen from European farms.",
    stock: 12
  },
  {
    id: 3,
    name: "Hemp Silk Evening Dress",
    price: 8900,
    category: "women",
    fabric: "Hemp Silk",
    images: [
      "https://images.unsplash.com/photo-1595777457583-95e059d581b8?w=800&q=80",
      "https://images.unsplash.com/photo-1566174053879-31528523f8ae?w=800&q=80"
    ],
    sizes: ["XS", "S", "M", "L"],
    description: "A luxurious evening dress made from hemp silk blend. Flows beautifully and feels divine.",
    careInstructions: "Dry clean only.",
    ethical: "Limited batch of 50 pieces. Carbon-neutral production.",
    stock: 8
  },
  {
    id: 4,
    name: "Bamboo Jersey Relaxed Tee",
    price: 2800,
    category: "women",
    fabric: "Bamboo",
    images: [
      "https://images.unsplash.com/photo-1618354691373-d851c5c3a990?w=800&q=80",
      "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=800&q=80"
    ],
    sizes: ["XS", "S", "M", "L", "XL"],
    description: "Super soft bamboo jersey tee with a relaxed fit. Your new everyday essential.",
    careInstructions: "Machine wash cold. Hang dry.",
    ethical: "Made from sustainably harvested bamboo fiber.",
    stock: 25
  },
  {
    id: 5,
    name: "Organic Cotton Tailored Shirt",
    price: 4200,
    category: "men",
    fabric: "Organic Cotton",
    images: [
      "https://images.unsplash.com/photo-1602810318383-e386cc2a3ccf?w=800&q=80",
      "https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?w=800&q=80"
    ],
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: "Classic tailored shirt in premium organic cotton. Timeless style meets ethical fashion.",
    careInstructions: "Machine wash cold. Iron while damp.",
    ethical: "Fair trade certified. Zero waste pattern cutting.",
    stock: 18
  },
  {
    id: 6,
    name: "Linen Casual Pants",
    price: 4800,
    category: "men",
    fabric: "Linen",
    images: [
      "https://images.unsplash.com/photo-1473966968600-fa801b869a1a?w=800&q=80",
      "https://images.unsplash.com/photo-1624378439575-d8705ad7ae80?w=800&q=80"
    ],
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: "Breathable linen pants perfect for warm days. Casual yet refined.",
    careInstructions: "Machine wash cold. Line dry.",
    ethical: "European linen. Small batch production.",
    stock: 14
  },
  {
    id: 7,
    name: "Hemp Canvas Tote Bag",
    price: 1800,
    category: "lifestyle",
    fabric: "Hemp Canvas",
    images: [
      "https://images.unsplash.com/photo-1590874103328-eac38a683ce7?w=800&q=80",
      "https://images.unsplash.com/photo-1548036328-c9fa89d128fa?w=800&q=80"
    ],
    sizes: ["One Size"],
    description: "Durable hemp canvas tote. Perfect for conscious shopping.",
    careInstructions: "Spot clean. Hand wash if needed.",
    ethical: "Made from 100% organic hemp. Plastic-free packaging.",
    stock: 30
  },
  {
    id: 8,
    name: "Organic Cotton Throw Blanket",
    price: 3500,
    category: "lifestyle",
    fabric: "Organic Cotton",
    images: [
      "https://images.unsplash.com/photo-1631679706909-1844bbd07221?w=800&q=80",
      "https://images.unsplash.com/photo-1584100936595-c0654b55a2e2?w=800&q=80"
    ],
    sizes: ["One Size"],
    description: "Cozy organic cotton throw blanket. Ethically made comfort for your home.",
    careInstructions: "Machine wash cold. Tumble dry low.",
    ethical: "GOTS certified organic cotton. Fair wages guaranteed.",
    stock: 20
  }
];

export const collections = [
  {
    id: 1,
    name: "Women",
    image: womenImage,
    description: "Timeless elegance meets ethical luxury"
  },
  {
    id: 2,
    name: "Men",
    image: menImage,
    description: "Refined essentials for the conscious man"
  },
  {
    id: 3,
    name: "Homeware",
    image: lifestyleImage,
    description: "Sustainable living, beautifully crafted"
  },
  {
    id: 4,
    name: "Siyaanish Signature",
    image: siyaanishsig,
    description: "Exclusive pieces, made in small quantities"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Priya Sharma",
    text: "The quality is unmatched. I love knowing my clothes are made ethically and sustainably.",
    rating: 5
  },
  {
    id: 2,
    name: "Arjun Mehta",
    text: "Finally, luxury fashion that aligns with my values. The linen pieces are incredible.",
    rating: 5
  },
  {
    id: 3,
    name: "Ananya Roy",
    text: "Beautiful craftsmanship and the fabrics feel amazing. Worth every rupee.",
    rating: 5
  }
];

export const faqs = [
  {
    question: "What makes Siyaanish different?",
    answer: "We combine luxury fashion with ethical production. Every piece is made from sustainable materials like organic cotton, hemp, and linen, using fair trade practices and small batch production."
  },
  {
    question: "How long does shipping take?",
    answer: "Delivery takes 8-15 days within India."
  },
  {
    question: "What is your return policy?",
    answer: "We offer 14-day returns for unworn items with tags attached. Please see our Return & Refund Policy for complete details."
  },
  {
    question: "Are your products really sustainable?",
    answer: "Absolutely. We use certified organic and plant-based materials, carbon-neutral shipping, and work only with fair trade certified suppliers."
  },
  {
    question: "Do you offer international shipping?",
    answer: "We ship worldwide. Please note that any customs duties, import taxes, or additional fees imposed by your country are the responsibility of the customer."
  }
];
